export default "__VITE_ASSET__XQes1PuG__"